/** Canonical (AWS-style) Secret Manager id of a GitHub organization's App
 * private key. Other providers rewrite it with their `replacer`. */
export const githubAppPrivateKeySecretId = (organizationId: string): string =>
  `p0/install/github/${organizationId}/private-key.pem`;

/** Canonical prefix that every access token secret of a GitHub organization
 * starts with. Other providers rewrite it with their `replacer`. */
export const githubAiAccessTokenPrefix = (organizationId: string): string =>
  `p0/access-token/github/${organizationId}/`;

/** The connector's Cloud Run service name. Its Lambda function name adds
 * "-aws". */
export const githubAiConnectorName = "p0-connector-github-ai";
